module.exports = __webpack_public_path__ + "img/support_b1.8ef3be83.png";